/**
 * In-memory per-session cache of boost IDs purchased in the lobby (non-TF games).
 * Used so selectBoostOnPurchase can be set correctly at selection time even if
 * the user selects another boost then re-selects the purchased one.
 * SP only: create one instance in action-game.pixi (LocalMatchSessionHost). MMS uses Redis (PurchasedBoostStore).
 * Clear when the player is locked in to a match (e.g. before createMatch in SP).
 */

const DEFAULT_SESSION_KEY = '__session__';

export class PurchasedBoostCache {
  /** userId -> set of purchased boost IDs. Use DEFAULT_SESSION_KEY for SP. */
  private readonly purchasedBySession: Map<string, Set<string>> = new Map();

  private getSetForSession(userId?: string): Set<string> {
    const key = userId ?? DEFAULT_SESSION_KEY;
    let set = this.purchasedBySession.get(key);
    if (!set) {
      set = new Set();
      this.purchasedBySession.set(key, set);
    }
    return set;
  }

  /** Call after a successful purchase. */
  public record(boostId: string, userId?: string): void {
    this.getSetForSession(userId).add(boostId);
  }

  public wasPurchased(boostId: string, userId?: string): boolean {
    return this.getSetForSession(userId).has(boostId);
  }

  public clear(userId?: string): void {
    const key = userId ?? DEFAULT_SESSION_KEY;
    this.purchasedBySession.delete(key);
  }
}
